<template>
  <div class="full-screen-loading-spinner">
    <LoadingSpinner size="100px"></LoadingSpinner>
  </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue';

export default {
  name: 'FullScreenLoadingSpinner',
  components: {
    LoadingSpinner,
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/variables";

.full-screen-loading-spinner {
  z-index: 1000;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
}
</style>
